import React from 'react';
import { Clock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

// Renders only for trial users. Shows the trial end date (MM/DD) and, when the
// trial ends within a week, a "Nd left" countdown. Theme-aware for the light
// (BetMaker) and dark (IntelliTix) headers.
export const TrialBadge = ({ theme = 'light' }) => {
  const { user } = useAuth();
  if (!user || typeof user !== 'object') return null;
  if (user.subscription_status !== 'trial') return null;

  const ends = user.trial_ends_at || user.subscription_ends_at;
  if (!ends) return null;
  const d = new Date(ends);
  if (isNaN(d.getTime())) return null;

  const mmdd = String(d.getMonth() + 1).padStart(2, '0') + '/' + String(d.getDate()).padStart(2, '0');
  const today = new Date(new Date().toDateString());
  const end = new Date(d.toDateString());
  const days = Math.round((end - today) / 86400000);
  const ended = days < 0;
  const urgent = !ended && days <= 2;

  const label = ended ? `Trial ended ${mmdd}` : `Trial ends ${mmdd}`;
  const countdown = !ended && days <= 7 ? ` · ${days}d left` : '';

  const base = 'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold border whitespace-nowrap';
  const cls = theme === 'dark'
    ? (ended || urgent
        ? 'bg-amber-500/15 text-amber-300 border-amber-400/40'
        : 'bg-emerald-500/15 text-emerald-300 border-emerald-400/40')
    : (ended || urgent
        ? 'bg-amber-100 text-amber-800 border-amber-300'
        : 'bg-amber-50 text-amber-700 border-amber-200');

  return (
    <span
      className={`${base} ${cls}`}
      data-testid="trial-ends-badge"
      title={ended ? 'Your free trial has ended' : `${days} day(s) left in your free trial`}
    >
      <Clock className="w-4 h-4" />
      {label}{countdown}
    </span>
  );
};

export default TrialBadge;
